/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';
import { set, isFunction } from 'lodash/fp';
import t from 'app/utils/translate';
import FriendsLoader from 'app/components/friends/common/FriendsLoader';
import ChallengesList from 'app/components/challenges/ChallengesList';
import { ASCENDING, DESCENDING } from 'app/constants/sortDirTypes';
import withSort from 'app/hoc/withSort';

type Props = {
  challengesData: Array<ChallengeData>,
  disableRowClick?: boolean,
  isFetching?: boolean,
  marginBottom?: string,
  onCheckBoxClick?: string => void,
  onCounterClick?: (string, number) => void,
  onNameClick?: string => void,
  onSort: string => void,
  pinnedChallengesAd?: Object,
  selectedIds?: Array,
  showChallengeEntryState?: boolean,
  showEnter?: boolean,
  showSportsIcon?: boolean,
  sortData: Array => Array,
  sortDescending: boolean,
  sortField?: string,
  sortFunc?: (Array<*>) => void,
  isTwoThirdSize?: boolean
};

const ListWrapper = glamorous.div(
  () => ({
    position: 'relative'
  }),
  ({ marginBottom }) => (marginBottom ? { marginBottom } : {})
);

const Section = glamorous.div(({ separate, theme }) =>
  separate
    ? {
        paddingBottom: theme.spacing.large
      }
    : undefined
);

class GroupedChallengesList extends React.Component<Props> {
  props: Props;

  static defaultProps = {
    disableRowClick: false,
    isFetching: false,
    marginBottom: undefined,
    onNameClick: undefined,
    onCounterClick: undefined,
    onCheckBoxClick: undefined,
    pinnedChallengesAd: undefined,
    selectedIds: [],
    showChallengeEntryState: true,
    showEnter: false,
    showSportsIcon: false,
    sortField: undefined,
    sortFunc: undefined,
    isTwoThirdSize: false
  };

  handleSort = (groupId: string, field: string) => {
    this.setState(({ sortDirection, sortField }: State) => ({
      sortDirection: set(
        groupId,
        sortDirection[groupId] === ASCENDING ? DESCENDING : ASCENDING
      )(sortDirection),
      sortField: set(groupId, field)(sortField)
    }));
  };

  render() {
    const {
      challengesData,
      marginBottom,
      onCounterClick,
      onCheckBoxClick,
      onNameClick,
      isFetching,
      disableRowClick,
      onSort,
      pinnedChallengesAd,
      selectedIds,
      showChallengeEntryState,
      showEnter,
      showSportsIcon,
      sortData,
      sortDescending,
      sortField,
      sortFunc,
      isTwoThirdSize
    } = this.props;

    return (
      <ListWrapper marginBottom={marginBottom}>
        {isFetching && <FriendsLoader showOverlay>{t('Fetching challenges...')}</FriendsLoader>}
        {challengesData.map(data => (
          <Section key={data.key} separate={data.separate}>
            <ChallengesList
              ad={data.key === 'sticky' ? pinnedChallengesAd : undefined}
              challenges={
                isFunction(sortFunc) && !sortField
                  ? sortFunc(data.challenges)
                  : sortData(data.challenges)
              }
              columns={data.columns}
              disableRowClick={disableRowClick}
              emptyMessage={data.emptyMessage}
              emptyTitle={data.emptyTitle}
              onCheckBoxClick={onCheckBoxClick}
              onCounterClick={onCounterClick}
              onNameClick={onNameClick}
              onSort={onSort}
              selectedIds={selectedIds}
              showPlaceholder={data.alwaysShow}
              sortDirection={sortDescending ? DESCENDING : ASCENDING}
              sortField={sortField}
              title={data.title}
              showChallengeEntryState={showChallengeEntryState}
              showEnter={showEnter}
              showSportsIcon={showSportsIcon}
              isTwoThirdSize={isTwoThirdSize}
            />
          </Section>
        ))}
      </ListWrapper>
    );
  }
}

const enhance = withSort();

export default enhance(GroupedChallengesList);
